import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { auth } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("oc_token");
    const cached = localStorage.getItem("oc_merchant");
    if (token && cached) {
      try {
        setMerchant(JSON.parse(cached));
      } catch { /* noop */ }
      auth.me().then(setMerchant).catch(() => {
        localStorage.removeItem("oc_token");
        localStorage.removeItem("oc_merchant");
        setMerchant(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { token, merchant: m } = await auth.login({ email, password });
    localStorage.setItem("oc_token", token);
    localStorage.setItem("oc_merchant", JSON.stringify(m));
    setMerchant(m);
    return m;
  };

  const signup = async (payload) => {
    const { token, merchant: m } = await auth.signup(payload);
    localStorage.setItem("oc_token", token);
    localStorage.setItem("oc_merchant", JSON.stringify(m));
    setMerchant(m);
    return m;
  };

  const logout = () => {
    localStorage.removeItem("oc_token");
    localStorage.removeItem("oc_merchant");
    setMerchant(null);
  };

  const refresh = async () => {
    const m = await auth.me();
    localStorage.setItem("oc_merchant", JSON.stringify(m));
    setMerchant(m);
    return m;
  };

  return (
    <AuthContext.Provider value={useMemo(
      () => ({ merchant, loading, login, signup, logout, refresh, setMerchant }),
      // login/signup/logout/refresh are stable within a render but re-created on each — acceptable since they close over the same setters
      [merchant, loading],
    )}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
